const RELOAD_COUNT_KEY = 'errorBoundaryReloadCount';
const RELOAD_TIMESTAMP_KEY = 'errorBoundaryReloadTimestamp';
const MAX_RELOAD_ATTEMPTS = 3;
const RELOAD_COUNT_RESET_MS = 60_000;

function isVersionMismatchError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const msg = `${error.message} ${error.stack ?? ''}`;
  return (
    error.name === 'ChunkLoadError' ||
    /Unexpected token|Unexpected identifier|expected expression/i.test(error.message) ||
    /Loading chunk .* failed/i.test(msg)
  );
}

// eslint-disable-next-line complexity
function shouldAttemptReload(
  storage: Storage = sessionStorage,
  now: () => number = Date.now,
): boolean {
  try {
    let count = parseInt(storage.getItem(RELOAD_COUNT_KEY) ?? '0', 10);
    const last = parseInt(storage.getItem(RELOAD_TIMESTAMP_KEY) ?? '0', 10);
    const current = now();

    if (last && current - last > RELOAD_COUNT_RESET_MS) {
      count = 0;
    }

    if (count >= MAX_RELOAD_ATTEMPTS) return false;

    storage.setItem(RELOAD_COUNT_KEY, String(count + 1));
    storage.setItem(RELOAD_TIMESTAMP_KEY, String(current));

    return true;
  } catch {
    return true;
  }
}

function clearReloadCount(storage: Storage = sessionStorage) {
  storage.removeItem(RELOAD_COUNT_KEY);
  storage.removeItem(RELOAD_TIMESTAMP_KEY);
}

export {
  clearReloadCount,
  isVersionMismatchError,
  MAX_RELOAD_ATTEMPTS,
  RELOAD_COUNT_KEY,
  RELOAD_COUNT_RESET_MS,
  RELOAD_TIMESTAMP_KEY,
  shouldAttemptReload,
};
